import MessageMultiselect from './MessageMultiselect';

export default MessageMultiselect;
